export default __webpack_public_path__ + "static/media/PerformanceScoreCup.5fa53bc6.png";